export const BACK_ONLINE = 'The server is back online'
